import './component.scss'
import './area_menu/component'
import './subsidy_area_menu/component'

function setupChannelIO() {
  document.getElementsByClassName('js-ChannelIO-openWorkflow').forEach(element => {
    element.addEventListener('click', () => {
      if (typeof window.ChannelIO === 'function') {
        window.ChannelIO('openWorkflow', element.dataset.channelId)
      } else {
        console.log(`call ChannelIO openWorkflow ${element.dataset.channelId}`)
      }
    })
  })
}

function setupAreaMenu() {
  const menuTriggers = document.querySelectorAll('.js-area-menu-trigger')
  const areaMenuContainer = document.querySelector('.js-area-menu-container')

  if (menuTriggers.length > 0 && areaMenuContainer) {
    const areaMenu = areaMenuContainer.querySelector('.area-menu')

    if (areaMenu) {
      menuTriggers.forEach(trigger => {
        trigger.addEventListener('mouseenter', () => {
          const allItems = document.querySelectorAll('.dropdown-links-menu__item')
          allItems.forEach(item => {
            item.classList.remove('dropdown-links-menu__item--hover')
          })

          const allAreaMenus = areaMenuContainer.querySelectorAll('.area-menu')
          allAreaMenus.forEach(menu => {
            menu.style.display = 'none'
          })

          const linkId = trigger.getAttribute('data-link-id')
          const targetAreaMenu = areaMenuContainer.querySelector(`[data-link-id="${linkId}"]`)
          if (targetAreaMenu) {
            targetAreaMenu.style.display = 'block'
          }

          const rect = trigger.getBoundingClientRect()
          const parentRect = trigger.closest('.dropdown-links-menu__container').getBoundingClientRect()

          areaMenuContainer.style.top = `${rect.bottom - parentRect.top - 8}px`
          areaMenuContainer.style.left = `${rect.left - parentRect.left + 13}px`

          areaMenuContainer.classList.add('dropdown-links-menu__area-menu-container--show')
          trigger.classList.add('dropdown-links-menu__item--hover')
        })

        trigger.addEventListener('mouseleave', (e) => {
          const relatedTarget = e.relatedTarget
          if (!areaMenuContainer.contains(relatedTarget)) {
            areaMenuContainer.classList.remove('dropdown-links-menu__area-menu-container--show')
            trigger.classList.remove('dropdown-links-menu__item--hover')
          }
        })
      })

      areaMenuContainer.addEventListener('mouseleave', (e) => {
        const relatedTarget = e.relatedTarget
        const isOverTrigger = Array.from(menuTriggers).some(trigger => trigger.contains(relatedTarget))

        if (!isOverTrigger) {
          areaMenuContainer.classList.remove('dropdown-links-menu__area-menu-container--show')
          menuTriggers.forEach(trigger => {
            trigger.classList.remove('dropdown-links-menu__item--hover')
          })
        }
      })

      areaMenuContainer.addEventListener('mouseenter', () => {
        areaMenuContainer.classList.add('dropdown-links-menu__area-menu-container--show')
      })
    }
  }

  const allMenuItems = document.querySelectorAll('.dropdown-links-menu__item')
  allMenuItems.forEach(item => {
    item.addEventListener('mouseenter', () => {
      if (!item.classList.contains('js-area-menu-trigger')) {
        if (areaMenuContainer) {
          areaMenuContainer.classList.remove('dropdown-links-menu__area-menu-container--show')
        }
        if (menuTriggers.length > 0) {
          menuTriggers.forEach(trigger => {
            trigger.classList.remove('dropdown-links-menu__item--hover')
          })
        }
      }
    })
  })
}

function setupSubsidyAreaMenu() {
  const menuTriggers = document.querySelectorAll('.js-subsidy-area-menu-trigger')
  const areaMenuContainer = document.querySelector('.js-subsidy-area-menu-container')

  if (menuTriggers.length > 0 && areaMenuContainer) {
    const areaMenu = areaMenuContainer.querySelector('.area-menu')

    if (areaMenu) {
      menuTriggers.forEach(trigger => {
        trigger.addEventListener('mouseenter', () => {
          const allItems = document.querySelectorAll('.dropdown-links-menu__item')
          allItems.forEach(item => {
            item.classList.remove('dropdown-links-menu__item--hover')
          })

          const allAreaMenus = areaMenuContainer.querySelectorAll('.area-menu')
          allAreaMenus.forEach(menu => {
            menu.style.display = 'none'
          })

          const linkId = trigger.getAttribute('data-link-id')
          const targetAreaMenu = areaMenuContainer.querySelector(`[data-link-id="${linkId}"]`)
          if (targetAreaMenu) {
            targetAreaMenu.style.display = 'block'
          }

          const rect = trigger.getBoundingClientRect()
          const parentRect = trigger.closest('.dropdown-links-menu__container').getBoundingClientRect()

          areaMenuContainer.style.top = `${rect.bottom - parentRect.top - 8}px`
          areaMenuContainer.style.left = `${rect.left - parentRect.left + 13}px`

          areaMenuContainer.classList.add('dropdown-links-menu__area-menu-container--show')
          trigger.classList.add('dropdown-links-menu__item--hover')
        })

        trigger.addEventListener('mouseleave', (e) => {
          const relatedTarget = e.relatedTarget
          if (!areaMenuContainer.contains(relatedTarget)) {
            areaMenuContainer.classList.remove('dropdown-links-menu__area-menu-container--show')
            trigger.classList.remove('dropdown-links-menu__item--hover')
          }
        })
      })

      areaMenuContainer.addEventListener('mouseleave', (e) => {
        const relatedTarget = e.relatedTarget
        const isOverTrigger = Array.from(menuTriggers).some(trigger => trigger.contains(relatedTarget))

        if (!isOverTrigger) {
          areaMenuContainer.classList.remove('dropdown-links-menu__area-menu-container--show')
          menuTriggers.forEach(trigger => {
            trigger.classList.remove('dropdown-links-menu__item--hover')
          })
        }
      })

      areaMenuContainer.addEventListener('mouseenter', () => {
        areaMenuContainer.classList.add('dropdown-links-menu__area-menu-container--show')
      })
    }
  }

  const allMenuItems = document.querySelectorAll('.dropdown-links-menu__item-search')
  allMenuItems.forEach(item => {
    item.addEventListener('mouseenter', () => {
      if (!item.classList.contains('js-subsidy-area-menu-trigger')) {
        if (areaMenuContainer) {
          areaMenuContainer.classList.remove('dropdown-links-menu__area-menu-container--show')
        }
        if (menuTriggers.length > 0) {
          menuTriggers.forEach(trigger => {
            trigger.classList.remove('dropdown-links-menu__item--hover')
          })
        }
      }
    })
  })
}

document.addEventListener('DOMContentLoaded', () => {
  setupChannelIO()
  setupAreaMenu()
  setupSubsidyAreaMenu()
})
